<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('media', {
            isLoading: state => state.isLoading,
            tags: state => state.tags,
            folders: state => state.folders,
            types: state => state.types,
            totalTypeCount: state => state.totalTypeCount,
            activeTags: state => state.activeTags,
            activeFolders: state => state.activeFolders
        })
    }
}
</script>

<template>
    <div class="list-group list-group--media-type" v-if="types">
        <a href="javascript:;" class="list-group-item js-media-type-item active" data-type-id="0">
            <span class="badge">{{totalTypeCount}}</span> All
        </a>

        <div class="list-group--scroll list-group-item p-0">
            <a href="javascript:;" v-for="type in types" class="list-group-item js-media-type-item" :data-type-id="type.id">
                <span class="badge">{{type.type_count}}</span> {{type.name}}
            </a>
        </div>
    </div>
</template>